import { render } from "./PPCard.vue?vue&type=template&id=5f154e99"
import script from "./PPCard.vue?vue&type=script&lang=js"
export * from "./PPCard.vue?vue&type=script&lang=js"

import "./PPCard.vue?vue&type=style&index=0&id=5f154e99&lang=css"

import exportComponent from "/tmp/build_4e4571bb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__